// Constants.
import * as ConsentsConstants from 'constants/ConsentsConstants';

const initialState = {
  isFetching: false,
  isFetched: false,
  consents: {},
};

export default function consents(state = initialState, action = {}) {
  switch (action.type) {
    case ConsentsConstants.LOAD_CONSENTS_REQUEST:
      return {
        ...state,
        isFetched: false,
        isFetching: true,
      };
    case ConsentsConstants.LOAD_CONSENTS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        consents: action.consents.consents,
      };
    case ConsentsConstants.LOAD_CONSENTS_FAILURE:
      return {
        ...state,
        isFetching: false,
        isFetched: false,
        consents: {},
      };
    case ConsentsConstants.UPDATE_CONSENTS_SUCCESS:
      return {
        ...state,
        isFetched: true,
        isFetching: false,
        consents: action.consents,
      }

    default:
      return state;
  }
}
